import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const ACCENT = '#69b59f';
const ACCENT_PLAYED = '#bb86fc';

// Colores para los tiers de Top Star
const GOLD = '#F4C430'; // Dorado brillante
const RED = '#DC143C'; // Rojo vibrante
const BLUE = '#1E88E5'; // Azul vibrante
const GREEN = '#2E7D32'; // Verde oscuro

const CustomSectionWrapper = ({
    title,
    color: colorKey = 'accent',
    mb = 2,
    mt = 0,
    padding = 1.25,
    children,
    fontSizeTitle = 14,
    ...rest
}) => {
    const theme = useTheme();

    const getAccentColor = () => {
        if (colorKey === 'accent') return ACCENT;
        if (colorKey === 'accent2') {
            return (theme.palette.border && theme.palette.border.accent2) || ACCENT_PLAYED;
        }
        if (colorKey === 'accent3') {
            return (theme.palette.border && theme.palette.border.accent3) || ACCENT_PLAYED;
        }
        if (colorKey === 'played') return ACCENT_PLAYED;
        // Colores para tiers de Top Star
        if (colorKey === 'gold') return GOLD;
        if (colorKey === 'red') return RED;
        if (colorKey === 'blue') return BLUE;
        if (colorKey === 'green' || colorKey === 'dark-green') return GREEN;
        return colorKey;
    };

    const accent = getAccentColor();

    // Función segura para aplicar alpha, manejando posibles errores
    const getAlphaColor = (color) => {
        try {
            // Si es un color rgb(), convertirlo a rgba()
            if (color.startsWith('rgb(')) {
                return color.replace('rgb(', 'rgba(').replace(')', ', 0.25)');
            }
            return alpha(color, 0.25);
        } catch (error) {
            // Si falla, intentar agregar transparencia hexadecimal
            if (color.startsWith('#')) {
                return `${color}40`; // 40 en hex es aproximadamente 25% de opacidad
            }
            // Para otros formatos, retornar el color original
            return color;
        }
    };

    return (
        <Box
            {...rest} // ojo: aquí ya no va "color"
            sx={{
                position: 'relative',
                width: '100%',
                border: 1,
                borderColor: theme.palette.border.main, // en vez de 'border.main'
                borderRadius: 2,
                p: padding,
                '::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 3,
                    background: `linear-gradient(90deg, ${accent} 0%, ${getAlphaColor(accent)} 60%, transparent 100%)`,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    pointerEvents: 'none',
                    zIndex: 1,
                },
                mt,
                mb,
            }}
        >
            {title ? (
                <Typography
                    fontSize={fontSizeTitle}
                    fontWeight={500}
                    borderBottom={1}
                    borderColor={theme.palette.border.main}
                    pb={1}
                    mb={1}
                >
                    {title}
                </Typography>
            ) : null}
            {children}
        </Box>
    );
};

export default CustomSectionWrapper;
